<template>
  <text-field
    dense
    hide-details="auto"
    :required="field.required"
    v-model="value"
    v-bind="{ ...$props, ...$attrs }"
    :prepend-icon="fieldIcon"
    @keydown="handleKeydown"
    :label="field.label"
    :placeholder="field.placeholder ?? field.label"
    :persistent-placeholder="Boolean(field.placeholder)"
    :rules="validationRules"></text-field>
</template>

<script>
import { CustomFieldType, upperFirst } from '@nova/core';
import customFieldTypeMixinOld from '@/modules/custom_fields/mixins/customFieldTypeMixinOld';
export default {
  mixins: [customFieldTypeMixinOld],
  methods: {
    handleKeydown(e) {
      if (CustomFieldType[upperFirst(this.fieldType)] === CustomFieldType.Number) {
        if (this.disallowedNumberCharacters.includes(e.key)) {
          e.preventDefault();
        }
      }
    }
  }
};
</script>
